/* ============
 * Create Page
 * ============
 *
 * This page creates client.
 */

import { mapGetters, mapMutations } from 'vuex';
import warehouseService from './../../../../services/warehouse';
import warehouseTransformer from './../../../../transformers/warehouse';
import countryService from './../../../../services/country';
import partnerService from './../../../../services/partner';
import Forms from './../../../../utils/forms/forms';
import debounce from 'debounce';
import minimumStockModal from './../../../../components/minimumStock/minimumStock.vue';
import shippingProviderService from './../../../../services/shippingProvider';
import accountService from './../../../../services/account';
import bulkDestroyProductModal from './../../../../components/bulkDestroyProductModal/bulkDestroyProductModal.vue';

export default {
  data() {
    return {
      formBasicInformation: new Forms({
        isActive: {
          value: true,
          type: 'switch',
        },
        typeName: {
          value: '',
          type: 'text',
        },
        name: {
          value: '',
          type: 'text',
        },
        location: {
          value: '',
          type: 'text',
        },
        partnerId: {
          value: '',
          type: 'select',
        },
        shippingProviders: {
          value: '',
          type: 'select',
          attributes: {
            multiple: true,
          },
        },
        // isBonded: {
        //   value: '',
        //   type: 'switch',
        // },
      }),
      formContactInformation: new Forms({
        firstName: {
          value: '',
          type: 'text',
        },
        lastName: {
          value: '',
          type: 'text',
        },
        email: {
          value: '',
          type: 'text',
        },
        phoneNumber: {
          value: '',
          type: 'text',
        },
      }),
      formAddressInformation: new Forms({
        streetName1: {
          value: '',
          type: 'text',
        },
        streetName2: {
          value: '',
          type: 'text',
        },
        postalCode: {
          value: '',
          type: 'text',
        },
        city: {
          value: '',
          type: 'text',
        },
        countryId: {
          value: 1,
          type: 'select',
        },
      }),
      loading: true,
      tabIndex: '2',
      products: [],
      productsLoading: true,
      transactionLoading: true,
      productFilter: {
        options: [],
        value: [],
        list: [],
        loading: true,
      },
      typeFilter: {
        options: [],
        value: [],
        list: [],
      },
      transactionTypeList: [],
      productDisplay: '',
      batchDisplay: '',
      transactionDisplay: 'all',
      limit: 10,
      batchFilter: {
        options: [],
        value: [],
        list: [],
        loading: true,
      },
      dropdownStateTransactions: false,
      hideOutOfStock: true,
      productShowAction: false,
      multipleSelection: [],
      productSearch: '',
    };
  },

  computed: {
    ...mapGetters({
      warehouse: 'currentWarehouse',
      // warehouseProducts: 'currentWarehouseProducts',
      warehouseProducts: 'paginateWarehouseProducts',
      // transactions: 'allWarehouseTransactions',
      // transactionsV2All: 'allWarehouseTransactionsV2',
      transactionsV2: 'paginateWarehouseTransactionsV2',
      account: 'account',
      countries: 'allCountries',
      municipalities: 'allMunicipalities',
      postals: 'allPostals',
      allPartners: 'allPartners',
    }),

    isDestructionWarehouse() {
      return this.warehouse.typeName === 'Destruction';
    },

    ediGrapesMoving() {
      return this.account.plan === 'EDI Grapsmoving';
    },

    productList() {
      return this.products.map((c) => {
        let data = {
          id: c.id,
          name: c.name,
          producer: c.supplierName,
          batchName: c.batchName,
          minimumStockLevel: c.minimumStockLevel !== 0 ? c.minimumStockLevel : '',
          qty: c.qty,
          qtyNumber: c.qtyNumber,
        };
        if (this.hasProduction() === false) {
          const { batchName, ...newData } = data;
          data = newData;
        }
        return data;
      });
    },
    // transactionList() {
    //   return this.transactions.map(c => ({
    //     via: c.via,
    //     code: c.code,
    //     id: c.transactionId,
    //     qty: c.totalQty,
    //     status: this.$t(`static.orders.status.${c.status}`),
    //     createdAt: c.createdAt,
    //   }));
    // },
    transactionListV2() {
      const newData = this.transactionsV2.items.map((c) => {
        let data = {
          via: `${c.via} #${c.code}`,
          client: c.customerName,
          batchName: c.batchName,
          id: c.parentModelId,
          // key: `${c.via} ${c.code}`,
          productName: c.productName,
          beforeqty: c.beforeQty,
          qty: c.adjustmentQty,
          afterqty: c.afterQty,
          warehouse: c.warehouse,
          createdAt: c.createdAt,
        };
        if (this.hasProduction() === false) {
          const { batchName, ...newData } = data;
          data = newData;
        }
        return data;
      });

      const self = this;
      return newData.filter((obj) => {
        const transType = obj.via.split('#')[0].trim();

        if (self.batchDisplay !== '' && self.productDisplay === '' && self.transactionDisplay === 'all') { return self.batchDisplay === obj.batchName; } else if (self.batchDisplay === '' && self.productDisplay !== '' && self.transactionDisplay === 'all') { return self.productDisplay === obj.productName; } else if (self.productDisplay === '' && self.batchDisplay === '' && self.transactionDisplay !== 'all') { return transType === self.transactionDisplay; } else if (self.batchDisplay !== '' && self.productDisplay !== '' && self.transactionDisplay === 'all') { return self.batchDisplay === obj.batchName && self.productDisplay === obj.productName; } else if (self.batchDisplay !== '' && self.productDisplay === '' && self.transactionDisplay !== 'all') { return self.batchDisplay === obj.batchName && transType === self.transactionDisplay; } else if (self.batchDisplay === '' && self.productDisplay !== '' && self.transactionDisplay !== 'all') { return self.productDisplay === obj.productName && transType === self.transactionDisplay; } else if (self.batchDisplay !== '' && self.productDisplay !== '' && self.transactionDisplay !== 'all') { return self.batchDisplay === obj.batchName && self.productDisplay === obj.productName && self.transactionDisplay === transType; }

        return obj;
      });
    },

    returnWarehouseType() {
      const isBondedText = this.warehouse.isBonded ? this.$t('static.warehouse.info.isBonded') : this.$t('static.warehouse.info.notBonded');
      return `${this.warehouse.typeName} ${isBondedText}`;
    },

    productSelectedCount() {
      return this.multipleSelection.length || 0;
    },
  },

  watch: {

    productSearch(value) {
      if (value === '') {
        this.allProduct(1, this.limit);
      }
    },

    hideOutOfStock() {
      this.allProduct(1, this.limit);
    },

    warehouseProducts(warehouseProducts) {
      this.onUpdateBatchFilter(warehouseProducts.items);
      this.productsLoading = true;
      this.products = warehouseProducts.items;
    },

    products(products) {
      setTimeout(() => { if (this.productsLoading === true && products) this.productsLoading = false; }, 1500);
    },

    /**
     * Listen to router changes, used to check query params that have changed to apply filters.
     *
     * @param  {Object} route Current route object.
     */
    $route() {
      this.urlCurrentTab();
      this.all(1, this.limit);
      this.allProduct(1, this.limit);
    },

    /**
     * Watches state update to inject on Forms class.
     *
     * @param  {Object} countries    The countries list.
     */
    countries(countries) {
      this.formAddressInformation.setOptions('countryId', countries.items);
    },

    allPartners(allPartners) {
      this.formBasicInformation.setOptions('partnerId', allPartners);
    },

    tabIndex(value) {
      this.assignTab(value);
    },

    multipleSelection(value) {
      this.productShowAction = false;
      if (value.length > 0) {
        this.productShowAction = true;
      }
    },

  },

  created() {
    this.show();
  },

  mounted() {
    this.urlCurrentTab();
    this.assignTab(this.tabIndex);
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalProps: 'SET_MODAL_PROPS',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    onProductSearch() {
      this.allProduct(1, this.limit);
    },

    onSelectAction(type) {
      if (type === 'minStockLevel') {
        this.setModalContent(() => minimumStockModal);
        this.setModalProps({
          type: 'bulk',
          entries: { selected: this.multipleSelection },
          queryProductWarehouse: this.queryProductWarehouse,
        });
        this.setModalCloseOnClick(false);
        this.setModalShowClose(true);
        this.setModalCloseOnPressEscape(false);
        this.toggleModal(true);
      }
    },

    resetSelected() {
      this.productShowAction = false;
      this.multipleSelection = [];
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    destroyProduct(product) {
      this.multipleSelection = [];
      if (!this.multipleSelection.find(p => +p.id === +product.id)) {
        this.multipleSelection.push(product);
      }
      this.destroySelectedProducts();
    },

    destroySelectedProducts() {
      this.setModalContent(() => bulkDestroyProductModal);
      this.setModalProps({
        selectedProducts: this.multipleSelection,
        warehouseId: +this.$route.params.id,
        onSave: this.handleBulkProductDestroy,
        onClose: this.handleBulkProductClose,
      });
      this.setModalCloseOnClick(false);
      this.setModalShowClose(false);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    handleBulkProductClose() {
      this.multipleSelection = [];
    },

    handleBulkProductDestroy(products) {
      return warehouseService
        .destroyProducts(
          this.$route.params.id,
          products.map(p => ({ id: p.id, qty: p.selectedQty }))
        )
        .then(() => {
          this.multipleSelection = [];
          this.$message({
            message: this.$t('static.warehouse.destroyProduct.success'),
            type: 'success',
          });
          this.allProduct(1, this.limit);
        })
        .catch((error) => {
          console.log(error);
          this.$message({
            message: this.$t('static.warehouse.destroyProduct.error'),
            type: 'error',
          });
        });
    },

    perPage(size) {
      accountService.rememberPerPage('post', { from: 'bill', perPage: size })
        .then((data) => {
          this.limit = data.size;
        }).catch((error) => {
          console.log(error);
        });
    },

    assignTab(value) {
      let tab = '';
      if (value == '3') {
        tab = '#transactions';
      } else if (value == '1') {
        tab = '#basics';
      } else {
        tab = '#products';
      }
      history.pushState({}, null, `/#${this.$route.path}${tab}`);
    },

    urlCurrentTab() {
      if (this.$router.currentRoute.hash == '#transactions') {
        this.tabIndex = '3';
      } else if (this.$router.currentRoute.hash == '#basics') {
        this.tabIndex = '1';
      } else {
        this.tabIndex = '2';
      }
    },

    toggleDropdownTransactions() {
      this.dropdownStateTransactions = !this.dropdownStateTransactions;
    },

    /**
    * Fetches paginated transaction.
    *
    * @param  {int} page The page number.
    * @param  {int} limit The number of items displayed on a page.
    */
    all: debounce(function (page, limit) {
      if (this.transactionLoading === false) this.transactionLoading = true;
      const filters = {
        productDisplay: this.productDisplay,
        batchDisplay: this.batchDisplay,
        transactionDisplay: this.transactionDisplay,
      };
      const params = {
        id: this.$route.params.id,
        page,
        limit,
        filter: JSON.stringify(filters),
      };
      warehouseService.transactionsV2(params)
        .then(() => {
          setTimeout(() => { if (this.transactionLoading === true) this.transactionLoading = false; }, 500);
        }).catch(() => {
          setTimeout(() => { if (this.transactionLoading === true) this.transactionLoading = false; }, 500);
        });
    }, 800),

     /**
    * Fetches paginated products.
    *
    * @param  {int} page The page number.
    * @param  {int} limit The number of items displayed on a page.
    */
    allProduct: debounce(function (page, limit) {
      if (this.productsLoading === false) this.productsLoading = true;
      const filters = {
        hide_out_of_stock: this.hideOutOfStock,
      };
      const params = {
        page,
        limit,
        search: this.productSearch,
        filter: JSON.stringify(filters),
      };
      warehouseService.products(this.$route.params.id, params)
        .then(() => {
          setTimeout(() => { if (this.productsLoading === true) this.productsLoading = false; }, 500);
        }).catch(() => {
          setTimeout(() => { if (this.productsLoading === true) this.productsLoading = false; }, 500);
        });
    }, 800),

    /**
     * Custom class for table row
     */
    rowClass() {
      return 'row-style';
    },

    /**
     * Switch tab when click product
     */
    switchTab(tab, event) {
      this.tabIndex = (tab.paneName) ? tab.paneName : '1';
    },

    /**
     * Details when click product tab item
     */
    showDetails(value) {
      this.tabIndex = '3';
      this.transactionLoading = true;

      this.productDisplay = '';
      this.productFilter.value = '';
      this.batchDisplay = '';
      this.batchFilter.value = '';

      this.productDisplay = value.name;
      this.productFilter.value = value.name;
      if (value.batchName !== '' && this.hasProduction() === true) {
        this.batchDisplay = value.batchName;
        this.batchFilter.value = value.batchName;
      }
      this.all(1, this.limit);
    },

    /**
     * Clear event products
     */
    clearProductFilter() {
      this.productDisplay = '';
      this.all(1, this.limit);
    },

    /**
     * Event products
     */
    eventProductFilter(value) {
      this.transactionLoading = true;
      this.productDisplay = value;
      this.all(1, this.limit);
    },

    /**
     * Event transactionsV2
     */
    eventTransactionsV2Filter(value) {
      this.transactionLoading = true;
      this.transactionDisplay = value;
      this.all(1, this.limit);
    },

    /**
     * Focus products
     */
    focusProductFilter() {
      // console.log('test');
    },

    /**
     * Clear batch
     */
    clearBatchFilter() {
      this.batchDisplay = '';
      this.all(1, this.limit);
    },

    /**
     * Focus batch filter
     */
    focusBatchFilter() {

    },

    /**
     * Filter batches
     */
    getFilterBatches(query) {
      this.batchFilter.loading = true;
      if (query !== '') {
        setTimeout(() => {
          this.batchFilter.options = this.batchFilter.list.filter(item => item.label.toLowerCase()
              .indexOf(query.toLowerCase()) > -1);
          this.batchFilter.loading = false;
        }, 200);
      } else {
        this.batchFilter.options = [];
        this.batchFilter.loading = false;
      }
    },

    /**
     * On update batches
     */
    onUpdateBatchFilter(value) {
      const unique = value.filter((set => f => !set.has(f.batchName) && set.add(f.batchName))(new Set()));
      return this.batchFilter.list = unique.map(item => ({ value: `${item.batchName}`, label: `${item.batchName}` }));
    },

    /**
     * Event batches
     */
    eventBatchFilter(value) {
      this.transactionLoading = true;
      this.batchDisplay = value;
      this.all(1, this.limit);
    },

    /**
     * Query list of transaction code
     */
    queryTransacType() {
      warehouseService.transactionTypes(this.$route.params.id)
      .then((response) => {
        this.onUpdatetransactionsV2Filter(response.data.data);
      });
    },

    /**
     * On update transactionsV2
     */
    onUpdatetransactionsV2Filter(value) {
      const tempData = value.map(item => ({ value: `${item}` }));
      const tempData2 = tempData;

      this.typeFilter.options = [];
      tempData2.unshift({ value: 'all' });
      const transTypes = this.$t('static.warehouse.transactions.filter.transactionType');
      this.typeFilter.options = tempData2.map((item) => {
        const temp = transTypes.find(item2 => item2.value === item.value);
        if (temp.value) return { value: temp.value, label: temp.label };
      });
      this.typeFilter.value = 'all';
    },

    /**
     * Filter products
     */
    getFilterProducts(query) {
      this.productFilter.loading = true;
      if (query !== '') {
        warehouseService.search(this.$route.params.id, { search: query })
        .then((response) => {
          this.productFilter.options = Object.assign({}, response.data).data.map(item => ({ value: item, label: item }));
          this.productFilter.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.productFilter.loading = false;
        });
      } else {
        this.productFilter.options = [];
        this.productFilter.loading = false;
      }
    },

    /**
     * Method to store the client
     */
    update() {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const supp = warehouseTransformer.send(
        Object.assign({}, this.formBasicInformation.data(), this.formContactInformation.data(), this.formAddressInformation.data())
      );
      warehouseService.update(this.$route.params.id, supp)
        .then(() => {
          this.$message({
            message: this.$t('static.warehouse.update.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'warehouse.index',
            query: {
              filter: 'active',
            },
          });
        }).catch((errors) => {
          this.formBasicInformation.loading = false;
          this.formBasicInformation.recordErrors(errors);
        });
    },

    /**
     * Fetches the warehouse object for editing.
     */
    show() {
      this.formBasicInformation.hideField('partnerId');
      this.loading = true;
      Promise.all([
        warehouseService.show(this.$route.params.id),
        // warehouseService.products(this.$route.params.id),
        // warehouseService.transactions({ id: this.$route.params.id }),
        countryService.all(),
        partnerService.all(),
        shippingProviderService.all(),
        // warehouseService.transactionsV2({ id: this.$route.params.id }),
      ]).then((data) => {
        this.loading = false;
        const ware = data[0];
        this.formBasicInformation.setOptions('shippingProviders', data[3]);
        // if (ware.isLocked === true) {
        //   this.formBasicInformation.setExtraAttr('shippingProviders', { disabled: true });
        // }
        this.formBasicInformation.assignData(ware);
        this.formBasicInformation.disableField('typeName');
        this.formBasicInformation.typeName = this.returnWarehouseType;
        this.formAddressInformation.assignData(ware.address);
        this.formContactInformation.assignData(ware.contact);
        this.allProduct(1, this.limit);
        this.all(1, this.limit);
        this.queryTransacType();
      });
    },
    link(warehouse) {
      const routeData = this.$router.resolve({
        params: { id: warehouse.warehouseId },
        name: 'warehouse.edit',
      });
      window.open(routeData.href, '_blank');
    },
    transactionLink(trans) {
      let name = '';
      if (trans.via == 'Stock count') {
        name = 'inventory.stock.view';
      } else if (trans.via == 'Stock Adjustment') {
        name = 'inventory.adjustment.view';
      } else if (trans.via == 'Order') {
        name = 'orders.edit';
      } else if (trans.via == 'Purchase') {
        name = 'inventory.purchase.view';
        // Transaction V2.
      } else if (trans.via.indexOf("SO") !== -1) {
        name = "orders.edit";
      } else if (trans.via.indexOf("OC") !== -1) {
        name = "orders.edit";
      } else if (trans.via.indexOf("PO") !== -1) {
        name = "inventory.purchase.view";
      } else if (trans.via.indexOf("AJ") !== -1) {
        name = "inventory.adjustment.view";
      } else if (trans.via.indexOf("SC") !== -1) {
        name = "inventory.stock.view";
      } else if (trans.via.indexOf("TW") !== -1) {
        name = "inventory.transfer.view";
      } else if (trans.via.indexOf("RS") !== -1) {
        name = "bills.creditNote";
      } else if (trans.via.indexOf("BI") !== -1) {
        name = "production.batches.view";
      }

      if (trans.id !== null && trans.id !== 0) {
        const routeData = this.$router.resolve({
          params: { id: trans.id },
          name,
        });
        window.open(routeData.href, '_blank');
      }
    },

    hasProduction() {
      if (this.account.modules.length > 0) {
        if (this.account.modules.find(module => module.name === 'Production')) return true;
      }
      return false;
    },

    /**
     * Activates the modal
     */
    activateModal(value) {
      this.setModalContent(() => minimumStockModal);
      this.setModalProps({
        entries: value,
        queryProductWarehouse: this.queryProductWarehouse,
      });
      this.setModalCloseOnClick(false);
      this.setModalShowClose(true);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    queryProductWarehouse() {
      this.resetSelected();
      this.allProduct(1, this.limit);
    },

  },

  components: {
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
    VForm: require('./../../../../components/form/form.vue'),
    VTable: require('./../../../../components/table/table.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/warehouse/edit/edit.js